import { isMobile } from '../helpers/isMobile';

export const gameNames = {
  dazzlingFire5: 'dazzlingFire5',
  dazzlingFire20: 'dazzlingFire20',
};

export const gameIds = {
  [gameNames.dazzlingFire5]: 234,
  [gameNames.dazzlingFire20]: 235,
};

export const applicationsId = {
  [gameIds[gameNames.dazzlingFire5]]: {
    production: '159',
    development: '242'
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    production: '160',
    development: '243'
  },
}

export const gameNameById = {
  [gameIds[gameNames.dazzlingFire5]]: gameNames.dazzlingFire5,
  [gameIds[gameNames.dazzlingFire20]]: gameNames.dazzlingFire20,

}

export const googleAnalyticsTokensByGame = {
  [gameIds[gameNames.dazzlingFire5]]: "GTM-TJQ2JV2M",
  [gameIds[gameNames.dazzlingFire20]]: "GTM-KZS28SZH",
}

export const matricesByGameId = {
  [gameIds[gameNames.dazzlingFire5]]: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
  [gameIds[gameNames.dazzlingFire20]]: {
    WinningLinesCoordinate: [
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 2, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 0, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 1, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 2, y: 1 },
        { x: 1, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 1, y: 2 },
        { x: 2, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 2, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 1, y: 1 },
        { x: 0, y: 2 },
        { x: 1, y: 3 },
        { x: 1, y: 4 },
      ],
      [
        { x: 0, y: 0 },
        { x: 2, y: 1 },
        { x: 0, y: 2 },
        { x: 2, y: 3 },
        { x: 0, y: 4 },
      ],
      [
        { x: 2, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 2, y: 4 },
      ],
      [
        { x: 1, y: 0 },
        { x: 0, y: 1 },
        { x: 2, y: 2 },
        { x: 0, y: 3 },
        { x: 1, y: 4 },
      ],
    ],
    allLineMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
    symbolsMatrix: [
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
      [0, 0, 0, 0, 0],
    ],
  },
}

export const winPopupConfigs = {
  popupPosition: {
    x: isMobile() ? 20 : 720,
    y: isMobile() ? 480 : 350,
  },
  amountConfigs: {
    type: 'text',
    x: 0,
    y: -15,
    fontChangeLimit: 8,
    style: {
      _fontFamily: 'rockwell',
      _fontWeight: 'bold',
      _wordWrap: true,
      _fill: ['#FFD700', '#FF9F00'],
      stroke: '#D20000',
      strokeThickness: 16,
      dropShadow: true,
      dropShadowAngle: Math.PI / 2,
      dropShadowBlur: 0,
      dropShadowDistance: 16,
      dropShadowColor: '#CB5407',
      padding: 4,
    },
    fontSizeBig: isMobile() ? 88 : 240,
    fontSizeSmall: isMobile() ? 56 : 220
  },
  animationConfigs: {
    oddsLimit: {
      big: 15,
      mega: 51,
      super: 101,
      epic: 201
    },
    winPopupAnimation: [
      {
        type: 'BIG',
        duration: 3000,
        animationNames: ['bigStart', 'bigLoop'],
      },
      {
        type: 'MEGA',
        duration: 5000,
        animationNames: ['bigStart', 'bigLoop', 'megaChange', 'megaLoop'],
      },
      {
        type: 'SUPER',
        duration: 7000,
        animationNames: ['bigStart', 'bigLoop', 'megaChange', 'megaLoop', 'superChange', 'superLoop'],
      },
      {
        type: 'EPIC',
        duration: 9000,
        animationNames: ['bigStart', 'bigLoop', 'megaChange', 'megaLoop', 'superChange', 'superLoop', 'epicChange', 'epicLoop'],
      },
      {
        type: 'MAX',
        duration: 12000,
        animationNames: ['maxStart', 'maxLoop'],
      },
    ],
    winPopupShownMinOdd: 15
  }
}
